import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const RecurringInvoiceList = React.lazy(() => import('@/modules/recurringInvoice/components/list/recurringInvoice-list'))
const RecurringInvoiceDetailView = React.lazy(() => import('@/modules/recurringInvoice/components/detail/recurring-invoice-detail.component'))
const RecurringInvoiceEditView = React.lazy(() => import('@/modules/recurringInvoiceV2/recurring-invoice-edit-view'))

const recurringInvoiceRoutes = (
  <>
    <Route path='recurringinvoice/*' element={<RedirectToPlural />} />
    <Route path='recurringinvoices' Component={RecurringInvoiceList} handle={{ title: 'Abos', options: { noBackgroundColor: true } }} />

    <Route path='recurringinvoices/:id' Component={RecurringInvoiceDetailView} />
    <Route path='recurringinvoices/:id/:action' Component={RecurringInvoiceDetailView} />

    <Route path='recurringinvoices/new' Component={RecurringInvoiceEditView} />
    <Route path='recurringinvoices/new/customer/:customerId' Component={RecurringInvoiceEditView} />
    <Route path='recurringinvoices/edit/:id' Component={RecurringInvoiceEditView} />
  </>
)

export default recurringInvoiceRoutes
